/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { groupSchema } from "./groupSchema.ts";
import { z } from "zod";

/**
 * @description Liste des logiciels attribués au membre dans l\'organisation
 */
export const groupDataSchema = z.lazy(() => groupSchema).and(z.object({
      "roles": z.array(z.lazy(() => groupSchema).describe("Représentation d'un détail (rôle, logiciel, etc.)")).describe("Liste des rôles attribués au membre pour le logiciel").optional()
      })).describe("Liste des logiciels attribués au membre dans l'organisation")